import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, ViewChild, OnInit, Input, Output, EventEmitter, Self, Optional, forwardRef} from '@angular/core';
import {UntypedFormControl, Validators, ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import { debounceTime, tap, switchMap, finalize, map, catchError, startWith, distinctUntilChanged } from 'rxjs/operators';
import { CollaboratorService } from 'app/services/collaborator.service';
import { Observable, of , BehaviorSubject} from 'rxjs';
import { AssignedTeamItem, Item } from 'app/models/item.inferface';
import { UserItem } from 'app/models/user-item.model';
import { ConsultantByDescriptionSuggestService } from 'app/services/suggest/consultant-by-description.suggest.service';
import { AssignedTeamMemberType } from 'app/enums/suggest.enum';
import { UserModel } from 'app/models/user.model';
import { AuthService } from 'app/services/auth.service';
import { PPFileDirectoryService } from 'app/services/pp-file-directory.service';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-collaborator-chips',
  templateUrl: './collaborator-chips.component.html',
  styleUrls: ['./collaborator-chips.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CollaboratorChipsComponent),
      multi: true
    }
  ]
})
export class CollaboratorChipsComponent implements OnInit, ControlValueAccessor {

  memberType = AssignedTeamMemberType;
   @Input() minWidth = null;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  clientAutoComplete$: Observable<AssignedTeamItem[] | UserItem[]> = null;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  chipCtrl: UntypedFormControl;
  filteredselectedItems: Observable<string[]>;
  selectedItems: BehaviorSubject<AssignedTeamItem[]> = new BehaviorSubject([]);
  @Input() permissionAdd = false;
  @Input() readonly= false;
  @Input() label: string;
  chipControlFormError = false;
  @Input() permissionRemove = false;
  // @Input() assistantInputHs;
  @Input() isTechnicians = false;

  @Input() endpoint:string = 'workflow';

  @ViewChild('groupInput') groupInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  onChange = (x) => {};
  onTouched = (x) => {};

  private minCharSearch: number = 0;
  currentUser: UserModel;

  constructor(
    private service: CollaboratorService,
    private authService: AuthService,
    private consultantSuggestService: ConsultantByDescriptionSuggestService,
    private ppFileDirectoryService: PPFileDirectoryService,
    // @Self() @Optional() public control: NgControl,
    ) {
      this.currentUser = this.authService.currentUser;
  }

  writeValue(obj: AssignedTeamItem[]): void {
    this.selectedItems.next(obj);
  }
  registerOnChange(fn: () => {}): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.chipCtrl.disable() : this.chipCtrl.enable();
  }

  ngOnInit() {
    this.chipCtrl = new UntypedFormControl();
    this.setObservable();
    this.selectedItems.subscribe(items => {
      this.onChange(items);
    });
  }

  private setObservable() {
    this.clientAutoComplete$ = this.chipCtrl.valueChanges.pipe(
      // delay emits
      debounceTime(300),
      distinctUntilChanged(),
      // use switch map so as to close previous subscribed events, before creating new once
      switchMap(value => {
        return value && value.length > this.minCharSearch ? this.search(value) : of(null);
      })
    );
  }

  colabLostFocus() {
  }

  search(value: string): Observable<UserItem[] | AssignedTeamItem[]> {
    switch(this.endpoint){
      case 'workflow':
        return this.consultantSuggestService.getTeamSuggestByDescription(value.toLowerCase())
          .pipe(catchError(_ => of(null)));
      case 'ppFileUsers': 
        return this.ppFileDirectoryService.getUsersAndGroups(value.toLowerCase())
          .pipe(catchError(_ => of(null)));
      case 'ppFileApprovers' : 
          return this.ppFileDirectoryService.getUsersAndGroupApprovers(value.toLowerCase())
            .pipe(catchError(_ => of(null)));
    }
  }

  add(event: MatChipInputEvent): void {}

  remove(item: AssignedTeamItem, indx: number): void {
    this.selectedItems.next(this.selectedItems.value.filter(x => x.id !== item.id || (x.id === item.id && x.type !== item.type)));
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const newItem = event.option.value;
    if (!this.selectedItems.value || !this.selectedItems.value.length) {
      this.selectedItems.next([newItem]);
    } else if (!this.validateExist(newItem)) {
      this.selectedItems.next([...this.selectedItems.value, newItem]);
    }
    this.groupInput.nativeElement.value = '';
    this.chipCtrl.setValue('');
  }
  validateExist(member: AssignedTeamItem): boolean {
    return this.selectedItems.value.some(x => x.id === member.id && x.type === member.type);
  }

  public get invalid(): boolean {
    return false;
    // return this.control ? this.control.invalid : false;
  }
}

